'use client';

import { PaginationEllipsis, PaginationItem } from '@/components/ui/pagination';
import { useRouter } from 'next/navigation';

export const useGeneratePaginationLinks = (baseUrl, currentPage, totalPages, isPending, onPageChange) => {
  const router = useRouter();
  const pages = [];
  let id = 0;

  const prefetchPage = page => {
    router.prefetch(`${baseUrl}/${page}`);
  };

  // Always show the first page
  pages.push(
    <PaginationItem
      key='first-page-button'
      disabled={isPending && 1 === currentPage}
      isActive={1 === currentPage}
      onClick={() => onPageChange(1)}
      onMouseEnter={() => prefetchPage(1)}
    >
      1
    </PaginationItem>
  );

  // If there are more than 7 pages, we'll add ellipses and create dynamic segments
  if (totalPages > 7) {
    // Add ellipsis if currentPage is far from the start
    if (currentPage > 4) {
      pages.push(<PaginationEllipsis key='start-ellipsis' />);
    }

    // Show pages around the current page
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
      pages.push(
        <PaginationItem
          key={id++}
          disabled={isPending && i === currentPage}
          isActive={i === currentPage}
          onClick={() => onPageChange(i)}
          onMouseEnter={() => prefetchPage(i)}
        >
          {i}
        </PaginationItem>
      );
    }

    // Add ellipsis if currentPage is far from the end
    if (currentPage < totalPages - 3) {
      pages.push(<PaginationEllipsis key='end-ellipsis' />);
    }
  } else {
    // If total pages <= 7, show all pages without ellipses
    for (let i = 2; i < totalPages; i++) {
      pages.push(
        <PaginationItem
          key={id++}
          disabled={isPending && i === currentPage}
          isActive={i === currentPage}
          onClick={() => onPageChange(i)}
          onMouseEnter={() => prefetchPage(i)}
        >
          {i}
        </PaginationItem>
      );
    }
  }

  // Always show the last page if there's more than one page
  if (totalPages > 1) {
    pages.push(
      <PaginationItem
        key='totalPages'
        onClick={() => onPageChange(totalPages)}
        isActive={totalPages === currentPage}
        disabled={isPending && totalPages === currentPage}
        onMouseEnter={() => prefetchPage(totalPages)}
      >
        {totalPages}
      </PaginationItem>
    );
  }

  return pages;
};
